module.exports = __webpack_public_path__ + "8aadd56092ce027b0edcc4870c99f260.svg";